import React from 'react'
import { Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../../../constants/colors'

interface ComparisonBarChartLabelsProps {
  previousLabel: string
  currentLabel: string
  previousCenterX: number
  currentCenterX: number
}

const labelBaseSx = {
  position: 'absolute' as const,
  bottom: 0,
  fontFamily: 'Lexend Deca',
  fontSize: '12px',
  lineHeight: '14px',
  textAlign: 'center' as const,
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap' as const
}

const ComparisonBarChartLabels: React.FC<ComparisonBarChartLabelsProps> = ({
  previousLabel,
  currentLabel,
  previousCenterX,
  currentCenterX
}) => {
  return (
    <>
      <Typography
        sx={{
          ...labelBaseSx,
          left: `${previousCenterX}px`,
          color: INTERAX_COLORS.thunderGrey
        }}
      >
        {previousLabel}
      </Typography>
      <Typography
        sx={{
          ...labelBaseSx,
          left: `${currentCenterX}px`,
          color: INTERAX_COLORS.white
        }}
      >
        {currentLabel}
      </Typography>
    </>
  )
}

export default ComparisonBarChartLabels
